<div class="flex flex-col items-center text-center w-full">
    <img
        class="w-[200px] max-[600px]:w-[150px] h-auto mb-4"
        src="./assets/images/modal-downtime.svg"
        alt="" />

    <h2 class="font-semibold text-[#231F20] text-2xl max-[600px]:text-xl leading-[1.3] mb-[14px]">
        {{ data.title | translate }}
    </h2>

    <div class="text-[#5F5B5B] text-[15px] max-[600px]:text-sm leading-[1.6] max-w-[440px]">
        <p class="m-0" [innerHTML]="data.message | translate"></p>
    </div>

    <div class="flex flex-col items-center gap-4 w-full mt-7">
        <div class="flex items-center justify-center gap-3 max-[600px]:w-full">
            <button
                type="button"
                class="bg-white text-[#00AFED] border-[1.5px] border-[#00AFED] rounded-[10px] py-3 px-6 min-w-[120px] font-semibold text-base leading-[normal] cursor-pointer transition-colors hover:bg-[#F0FAFF] max-[600px]:flex-1 max-[600px]:min-w-0 max-[600px]:px-[14px]"
                [mat-dialog-close]="false">
                {{ 'button.close' | translate }}
            </button>
            <button
                type="button"
                class="bg-[#00AFED] text-white border-none rounded-[10px] py-3 px-6 min-w-[120px] font-semibold text-base leading-[normal] cursor-pointer transition-colors hover:bg-[#009AD6] max-[600px]:flex-1 max-[600px]:min-w-0 max-[600px]:px-[14px]"
                [mat-dialog-close]="true">
                {{ 'askPodPopup.tryAgain' | translate }}
            </button>
        </div>

        <div class="flex items-start gap-[3px] mt-1">
            <svg
                class="w-3 h-3 shrink-0 text-[#8A929C] mt-0.5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <span
                class="text-[11px] text-[#8A929C] leading-[1.5]"
                [innerHTML]="'askPodPopup.downtimeSupport' | translate"></span>
        </div>
    </div>
</div>
